import React from 'react';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-178" data-mp="2lstkdivokeg4">
      <div className="mx-auto max-w-4xl text-center" data-id="element-179" data-mp="2lqgu8ifrqxrz">
        <h2 className="text-2xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-180" data-mp="30hzit4mp20my">
          ❌ ¿Cuántos chats más vas a responder sin cerrar una sola venta?
        </h2>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-gray-300 sm:text-base" data-id="element-181" data-mp="39h4fe5ep3jwh">
          Sos un mayorista serio. Tenés el stock. Tenés el precio. Pero nadie te
          dijo que sin sistema, el WhatsApp trabaja en contra tuya las 24 horas.
        </p>

        <ul className="mt-10 grid gap-4 text-left sm:grid-cols-2" data-id="element-182" data-mp="3eh8ld1hz8w8g">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl border border-red-500/20 bg-ink-900 p-5" data-id="element-183" data-mp="1p1ixiuogkps6">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-184" data-mp="1k52ak3szwhgo">
                ❌
              </span>
              <span className="text-sm leading-relaxed text-gray-300" data-id="element-185" data-mp="jbadeyq439eo">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 text-lg font-extrabold text-white sm:text-xl" data-id="element-186" data-mp="sd04u4jzu8cg">
          ¿Y si este fuera el último lunes que empezás así?
        </p>
      </div>
    </section>;
}